import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { OrderServiceRow_orderService$key } from '__generated__/OrderServiceRow_orderService.graphql';

type Props = {
  orderService: OrderServiceRow_orderService$key;
};

const OrderServiceRow: FC<Props> = ({ orderService }) => {
  const { name, itemPrice, price, amount } = useFragment(
    graphql`
      fragment OrderServiceRow_orderService on OrderItem {
        name
        itemPrice
        price
        amount
      }
    `,
    orderService
  );

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell align="center">€{itemPrice}</TableCell>
      <TableCell align="center">{amount}</TableCell>
      <TableCell align="center">€{price}</TableCell>
    </TableRow>
  );
};

export default OrderServiceRow;
